export default __webpack_public_path__ + "profile_sm.6f164335.png";